const pt = {
    9000001: " 2023聖誕杯",
    9000002: "SuperEx合約錦標賽",
    9000003: "贏取30,000USDT競賽獎金",
    9000004: "参赛人数",
    9000005: "已解锁奖池（USDT）",
    9000006: "交易量排名资格赛",
    9000007: "盈利率排名資格賽",
    9000008: "盈利額排名資格賽",
    9000009: `交易量排名赛，解锁最高 <span style="color: #ffc72b;">20,000</span> USDT 奖金池`,
    9000010: "根據參賽人數解鎖對應獎池，參賽人數越多解鎖獎池越大，最高20,000USDT獎金池",
    9000011: "奖池金额",
    9000012: "活动期间每天10:00（UTC）更新",
    9000013: "獎勵預估",
    9000014: "期間纍計期貨交易金額",
    9000015: "奖励规则",
    9000016: "根据参赛人数解锁对应奖池，参赛人数越多解锁奖池越大，最高20,000U奖金池",
    9000017: "奖池金额（USDT）",
    9000018: "活动盈利率排名",
    9000019: "报名",
    9000020: "活动盈利额排名",
    9000021: "已结束",
    9000022: `盈利率排名賽，瓜分 <span style="color: #ffc72b;">{moneyPond}</span> USDT 獎金`,
    9000023: `盈利額排名賽，瓜分 <span style="color: #ffc72b;">{moneyPond}</span> USDT 獎金`,
    9000024: "累计合約盈利率",
    9000025: "纍計合约盈利金額",
    9000026: "未开始",
    9000027: "參賽用戶盈利額排名前50名獲得獎勵，可參考交易排名獎勵規則獲取贈金獎勵",
    9000028: "參賽用戶盈利率排名前50名可獲得獎勵，可參考交易排名獎勵規則獲取獎勵",
    9000029: "活動交易額排名",
    9000030: "",
 
    //交易合约积分
    9100001: 'Acumular Pontos',
    9100002: 'Receber Airdrop',
    9100003: 'Resgatar Recompensas',
    9100004: 'Saldo de pontos',
    9100005: 'Detalhes',
    9100006: 'Pontos de check-in',
    9100007: 'Pontos de Negócio',
    9100008: 'Pontos de convite',
    9100009: 'Pontos de Bônus',
    9100010: 'Sorteio de sorte',
    9100011: 'Obter pontos',
    9100012: 'Regras de Pontos',
    9100013: 'Detalhes dos pontos',
    9100014: 'Você precisa se registrar para participar deste evento. Clique para se registrar.',
    9100015: 'Negociou por {day} dias consecutivos e ganhou {num} pontos',
    9100016: 'Pontos ganhos hoje {num}',
    9100017: 'Prêmio de pontos',
    9100018: 'Cada sorteio consome {point} pontos，e o máximo de {num} sorteios por dia é permitido',
    9100019: 'Número de sorteios hoje',
    9100020: 'Usuário',
    9100021: 'Pontos',
    9100022: 'Saldo de pontos insuficiente',
    9100023: 'Saldo de pontos insuficiente. Por favor, obtenha pontos antes de participar do sorteio.',
    9100024: 'Número de sorteios atingiu o limite!',
    9100025: 'O número de sorteios hoje atingiu o limite. Tente novamente amanhã.',
    9100026: 'Como obter pontos',
    9100027: 'Registre-se para participar da atividade de negociação de futuros e ganhar pontos.',
    9100028: 'Inscrição bem-sucedida',
    9100029: 'Você se inscreveu para participar da atividade de negociação de contratos futuros para ganhar pontos. Vá negociar para ganhar mais pontos (você não terá mais direito a recompensas de comissão e cashback).',
    9100030: 'Após cancelar sua inscrição, você não receberá mais pontos. Tem certeza de que deseja cancelar sua inscrição?',
    9100031: 'Centro de Atividades de Pontos de Troca',
    9100032: 'Obter pontos',
    9100033: 'Você precisa se registrar para participar deste evento. Clique para se registrar.',
    9100034: 'Você pode ganhar pontos ao participar continuamente do contrato.',
    9100035: 'Os usuários podem ganhar pontos por todas as negociações de futuros.',
    9100036: 'Pontos de classificação',
    9100037: 'Os cinco principais usuários do ranking diário de negociações receberão pontos adicionais de bônus.',
    9100038: 'Usuários convidados recebem pontos e o convidador pode ganhar pontos bônus.',
    9100039: '{guy} Já ganhou<span style="color:#D9A31A"> {num} pontos!</span>',
    9100040: 'Participe do Sorteio Agora!',
    9100041: 'Parabéns por conseguir',
    9100042: 'Todos os tipos',
    9100043: 'Ficar nesta página',
    9100044: 'Inscreva-se para participar',
    9100045: 'Continuar negociando',
    9100046: 'No momento não há eventos em andamento. Fique atento para atualizações…',
    9100047: 'Acumule pontos, ganhe airdrops e troque-os por tokens SCS.',
    9100048: '',
    9100049: '',
 
    9100050: 'Datas',
    9100051: 'Selecionar data de início',
    9100052: 'Hora de término',
    9100053: 'a',
    9100054: 'Tipo',
 
    9100055: 'Pontos ganhos = volume de negociação * 1% (a dificuldade será ajustada conforme o volume total de negociações da plataforma aumenta).',
    9100056: 'Por exemplo: o usuário utiliza uma posição com margem de 100 USDT*100X=10000 USDT',
    9100057: 'Portanto, você só precisa de um depósito de 100 USDT para obter 100 pontos.',
    9100058: 'Os pontos de negociação são a única forma de obter o token da plataforma SCS.',
    9100059: 'Pontos bônus extras = total de pontos do dia * proporção de recompensa por classificação',
    9100060: 'Ranking',
    9100061: 'Primeiro lugar',
    9100062: 'Segundo lugar',
    9100063: 'Terceiro lugar',
    9100064: 'Quarto lugar',
    9100065: 'Quinto lugar',
    9100066: 'Usuários convidados recebem pontos e o convidador pode ganhar pontos bônus.',
    9100067: 'Fator de nível',
    9100068: 'Fórmula de cálculo: pontos de referência obtidos = pontos obtidos pelo convidado * coeficiente de nível',
    9100069: 'O coeficiente de nível será ajustado de acordo com a situação real',
    9100070: `Por exemplo: O usuário B participa de uma atividade de pontos, e seu convidador é o usuário A, e o número de convites do usuário A atingiu o Nível 3. O usuário B acumulou pontos = 360.000;`,
    9100071: 'Então, os pontos de promoção acumulados que o usuário A pode obter = 360.000 * 30% = 108.000',
    9100072: 'Coeficiente de recompensa',
    9100073: '1 usuário de negociação',
    9100074: 'O volume de negociação atinge 5 milhões',
    9100075: 'O volume de negociações atinge 20 milhões',
 
    9100076: 'Transferir',
 
    //热币
    9100080: 'Terminado',
    9100081: 'Clique em ‘Participar’ para ganhar prêmios',
    9100082: 'Ver Regras',
    9100083: 'Inscreva-se agora',
    9100084: 'Eventos',
    9100088: 'Ir para o trading',
    9100089: 'Depositar',
    9100090: 'Você já registrou isso  ',
    
    9100091: 'Este evento terminou, aguarde o próximo!',
    9100092: 'O evento ainda não começou, por favor, aguarde.',
    9100093: '',
    9100094: '',
 
    //api key
    9100105: 'Criar chave API',
    9100106: 'Ver Documentação da API',
    9100107: 'Sistema de negociação integrado',
    9100108: 'Criar/Gerir Chave API',
    9100109: 'Implantar API',
    9100110: 'Negociação e Pedidos',
    9100111: 'Uma plataforma de negociação de ativos digitais líder',
    9100112: 'Uma ampla variedade de serviços de negociação e gestão de ativos digitais para atender às diversas necessidades de negociação.',
    9100113: 'Oferecendo melhores serviços',
    9100114: 'Taxas de negociação mais favoráveis, valores de negociação mais altos, funções de gerenciamento de conta mais flexíveis, etc.',
    9100115: 'A escolha de milhões de usuários',
    9100116: 'Garantindo um ambiente de negociação seguro, oferecendo suporte profissional ao cliente, ajudando você a avançar de forma consistente no mundo dos ativos digitais.',
    9100117: 'Como criar uma chave API no SuperEx?',
    9100118: 'SuperEx 的 API 文档在哪里可以查看？',
    9100119: '在 SuperEx 交易发现了问题怎么办？',
    9100120: 'Onde posso ver a documentação da API da SuperEx?',
    9100121: 'Acesse a API SuperEx para negociações mais rápidas e suaves.',
    9100122: `Ao fazer login, passe o mouse sobre o avatar - 'Gerenciamento de API' e clique em 'Criar chave de API' para criar sua chave de API na SuperEx. Nota: Se você não estiver logado, precisará fazer login em sua conta SuperEx primeiro. Você também pode criar sua chave de API pelo link 'APIs' na barra de navegação inferior.`,
    9100123: 'Você pode clicar em<a style="color:#d1a53e">API文档</a>，para ver a documentação da API do SuperEx.',
    9100124: `Se você encontrar algum problema ou tiver sugestões durante o uso, pode entrar em contato conosco das seguintes maneiras: <br> entre em contato com o suporte através do "Centro de Ajuda" no site oficial ou enviando um e-mail para support@superex.com.`,
    9100125: `Para usar a API da SuperEx, você primeiro precisa:<br>
Registrar e fazer login na sua conta da SuperEx.<br> 
Criar uma chave de API, que gerará um access_key e um secret_key para você.<br>  
Utilizar este access_key e secret_key para assinar suas requisições.<br>
Dependendo das suas necessidades, você pode utilizar várias APIs fornecidas pela SuperEx, como a API de Dados de Mercado, API de Negociação e API de Conta. Certifique-se de que cada requisição siga as instruções na<br> documentação da API, com os cabeçalhos HTTP e assinaturas adequados.<br>`,
    9100126: 'Gestão',
    9100127: 'Criar nova chave de API',
    9100128: 'Nome da chave API',
    9100129: 'Insira um nome para a chave API  ',
    9100130: 'Configurações de Permissão',
    9100131: 'Ler',
    9100132: 'Trocar',
    9100133: 'Lista de IP permitidos (opcional)',
    9100134: 'Você pode vincular até 10 endereços IP a cada chave API, separados por vírgulas.',
    9100135: 'Li e concordo com',
    9100136: 'aviso de risco para usuários de API',
    9100137: 'Criar',
    9100138: `A SuperEx oferece uma API poderosa que permite o uso de serviços como consulta de mercado e negociação automática. Consulte a [Documentação da API] para saber como utilizá-la.`,
    9100139: 'Cada conta pode criar até 10 chaves API.',
    9100140: `Chaves de API que não estão vinculadas a um IP expirarão automaticamente após 90 dias. Se você pretende usá-las por um longo período, pode renová-las na seção 'Minhas Chaves de API' — 'Ação' — 'Renovar', estendendo o prazo de validade por mais 90 dias. Chaves de API vinculadas a IPs não têm limite de expiração.`,
    9100141: 'Minha Chave API',
    9100142: 'Permissões',
    9100143: 'Endereço IP',
    9100144: 'Renovar',
    9100145: 'Criar uma chave API requer que você deposite qualquer valor em sua carteira à vista para ativar sua conta.',
    9100146: 'Confirmar a renovação da chave API atual?',
    9100147: 'Não divulgue sua Access Key e Secret Key para evitar perda de ativos.',
    9100148: `Por razões de segurança, recomenda-se vincular chaves de API a endereços IP específicos. Uma chave de API pode ser vinculada a um máximo de 20 endereços IP ou segmentos de IP. Você pode inserir um único endereço IP ou vários endereços diretamente, separando-os com uma vírgula. Por exemplo: 192.168.1.1,192.168.1.2`,
    9100149: 'Após uma renovação bem-sucedida, a data de expiração será recalculada. Se você usar a Chave de API a longo prazo, recomenda-se vincular um endereço IP. As Chaves de API vinculadas não expirarão e também são mais seguras.',
    9100150: 'Confirmar a exclusão da chave API atual?',
    9100151: 'Você precisa entender os seguintes riscos:',
    9100152: `Sua Chave API está intimamente relacionada à segurança da sua conta. Qualquer pessoa que conheça sua Chave API pode potencialmente controlar os ativos da sua conta. Portanto, por favor, mantenha-a em segurança, não a divulgue a terceiros e não a carregue em sites ou fóruns de terceiros.`,
    9100153: `Se sua chave da API for vazada devido a motivos pessoais, incluindo, mas não se limitando a questões de segurança de ativos e perdas econômicas, você deve arcar com todas as responsabilidades decorrentes disso, e não assumiremos nenhuma responsabilidade.`,
    9100154: 'Aviso de Risco',
    9100155: 'Estou ciente e disposto a assumir o risco.',
    9100156: 'Salvo',
    9100157: 'Configurações de Permissão',
    9100158: 'A Chave Secreta é exibida apenas uma vez e não pode ser recuperada se perdida, por favor, mantenha-a em segurança.',
    9100159: 'Não divulgue sua Access Key e Secret Key para evitar perda de ativos.',
    9100160: 'Se você esquecer sua Chave Secreta, exclua este par de chaves e solicite um novo.',
    9100161: 'Oferecemos APIs poderosas para ajudá-lo a integrar recursos de negociação em seus aplicativos de forma eficiente. As APIs são categorizadas em Conta, Negociação e Dados de Mercado, permitindo que você configure as permissões necessárias e implemente negociação automatizada via API.',
    9100162: 'Data Criada',
    9100163: 'Criar nova chave de API',
    9100164: 'Editar',
    9100165: 'Data de Validade',
    9100166: 'Excluir',
    9100167: 'Criação bem-sucedida',
    9100168: 'Lembrete Amigável',
    9100169: 'Entendi',
    9100170: 'aviso de risco para usuários de API',
    9100171: 'Formato de IP incorreto',
    9100172: '',
    //自由区二维码分享页面
    9100095: 'SuperEx Mercado Livre, um mundo cripto dos usuários, pelos usuários, para os usuários.',
    9100096: 'Abrir o App',
    9100097: '',
    9100098: '',

    //代理商
    101738: 'Torne-se um agente SuperEx e aproveite altas comissões!',
    101739: 'Convide seus amigos para negociar com o SuperEx e ganhe 50% da comissão. Comece a ganhar comissões após suas indicações realizarem negociações de contratos. Veja as regras.',
    101740: 'Torne-se um agente',
    101741: 'Como posso obter comissões?',
    101742: 'Candidate-se para ser um agente',
    101743: 'Se você possui comunidade, seguidores nas mídias e outros recursos, pode se inscrever para se tornar um agente e, após a aprovação, poderá ser promovido a agente.',
    101744: 'Promover SuperEx',
    101745: 'Compartilhe seu link de convite com sua comunidade, seguidores ou outros canais para divulgação promocional.',
    101746: 'Obter comissão',
    101747: 'Você pode ganhar comissões quando novos usuários se inscrevem e negociam através do seu link de convite.',
    101748: 'Quanto posso ganhar de comissão?',
    101749: 'Ao convidar usuários para negociar no SuperEx, você ganha 20% da comissão do seu amigo como bônus de convite. ',
    101750: 'Se você se tornar um agente do SuperEx, também receberá 50% de bônus de agente.',
    101751: 'Por que ser um agente SuperEx?',
    101752: 'Alta comissão',
    101753: 'Rebate de comissão de 50%',
    101754: 'Suporte de Tráfego de Usuário',
    101755: 'Suporte profissional de tráfego, acesso fácil à receita',
    101756: 'Suporte de Marca',
    101757: 'Eventos offline globais com presentes personalizados.',
    101758: 'Eventos offline globais',
    101759: 'Reunião global offline da SuperEX, os melhores encontros da indústria, suporte integral para cada agente, ajudando a aumentar seus ganhos!',
    101760: 'Revisão falhou',
    101761: 'Agentes',
    101762: 'Gestão de Canais',
    101763: 'Criar Canal',
    101764: 'Canais Afiliados',
    101765: 'Método de Promoção',
    101766: 'Nome do Canal',
    101767: 'Data Criada',
    101768: 'Editar',
    101769: 'Proporção de rebate de contratos',
    101770: 'Taxa de reembolso à vista',
    101771: 'Gestão de Promoções',
    101772: 'Código de convite',
    101773: 'Código de convite',
    101774: 'Número restante de links de referência que podem ser criados',
    101775: 'Amigos',
    101776: 'Código de convite do agente',
    101777: 'Número de referências de agentes',
    101778: 'Códigos de convite regulares',
    101779: 'Número regular de referências',
    101780: 'Link de convite',
    101781: 'Canais Regulares',
    101782: 'Painel de Dados',
    101783: 'Depósitos',
    101784: 'Valor da transação',
    101785: 'Comissão',
    101786: 'Código de Convite',
    101787: 'Relação de Convite Móvel',
    101788: 'Relatórios de Contratos',
    101789: 'Relatórios Spot',
    101790: 'Transações',
    101791: 'Centro de Liquidação',
    101792: 'Liquidação de Contrato',
    101793: 'Liquidação à Vista',
    101794: 'Comissão Estimada',
    101795: 'Registro de Saque',
    101796: 'Ver Ativos',
    101797: 'Valor Retirado',
    101798: 'Comissão Acumulada',
    101799: 'Os tokens atuais não atendem ao valor de retirada. Você pode convidar mais usuários para negociar e receber recompensas.',
    101800: 'Visão Geral dos Dados do Contrato',
    101801: 'Visão Geral dos Dados Spot',
    101802: 'Detalhes do Contrato',
    101803: 'Detalhes de Spot',
    101804: 'Todas as Direções',
    101805: 'Comissão Estimada do Agente',
    101806: 'Comissão Estimada do Usuário',
    101807: 'Hora da Transação',
    101808: 'Para regras detalhadas, veja o anúncio da SuperEx.',
    101809: 'Formulário de Inscrição para Agentes SuperEx',
    101810: 'Seu idioma',
    101811: 'Em qual país você está? (Exemplo: Irã)',
    101812: 'Qual é a sua plataforma/principal canal?',
    101813: 'Quantos seguidores/fãs/usuários você tem na sua plataforma/mídia social/site?',
    101814: 'Preencha o link da sua principal plataforma/canal (insira a URL completa)',
    101815: 'Outros canais sociais / links de websites (insira o URL completo)',
    101816: 'Seu nome',
    101817: 'Preencha os canais de mídia social para contatá-lo rapidamente (por exemplo: Telegram id @xxx)',
    101818: 'Onde você soube sobre o programa de agentes?',
    101819: 'Amigo',
    101820: 'Informações adicionais que você pode compartilhar conosco, como sobre você e uma breve introdução ao seu canal.',
    101821: 'Ótimo!',
    101822: 'Você completou com sucesso a aplicação de agente da SuperEx. Após a revisão, notificaremos você por e-mail.',
    101823: 'O período de tempo não pode exceder 3 meses.',
    101824: 'Sucesso',
    101825: 'Todas as retiradas',
    101826: 'Retirado',
    101827: 'Os tokens atuais não atendem ao valor de retirada. Você pode convidar mais usuários para negociar e receber recompensas.',
    101828: 'Gestão de Usuários',
    101829: 'ID do Usuário',
    101830: 'Proporção de Rebate de Futuros',
    101831: 'Proporção de Rebate à Vista',
    101832: 'Tempo de Registro',
    101833: 'Detalhes da Transação',
    101834: 'Comprar Longo',
    101835: 'Vender a descoberto',
    101836: 'Vender Longo',
    101837: 'Comprar Venda',
    101838: 'Tempo de Saque',
    101839: 'Moeda de saque',
    101840: 'Quantidade de saques',
    101841: 'Comissão',
    101842: 'Valor Retirável',
    101843: 'Retirada',
    101844: 'Comunidade',
    101845: 'Email (este e-mail será utilizado para receber informações do agente, verifique sua pasta de spam se nenhuma mensagem de verificação for encontrada)',
    101846: 'Código de Verificação',
    101847: 'Sua solicitação está em análise. Por favor, aguarde. Notificaremos por e-mail assim que for aprovada.',
    101848: 'Desculpe, sua solicitação de agente não foi aprovada.',
    101849: 'Reaplicar',
    101850: 'Visão Geral dos Dados',
    101851: 'Taxa de comissão do contrato de agentes',
    101852: 'Taxa de comissão para agentes',
    101853: 'Você foi desqualificado como agente. Se tiver dúvidas, entre em contato com o administrador.',
    101854: 'Todo o Tempo',
    101855: 'Ontem',
    101856: 'Este Mês',
    101857: 'Último Mês',
    101858: 'Número de Traders',
    101859: 'Depósito Total',
    101860: 'Selecione o código de convite',
    101861: 'Rendimento bruto',
    101862: 'Comissão de Contrato Futuros',
    101863: 'Comissão Spot',
    101864: 'Aguardando',
    101865: 'Retirado',
    101866: 'A ser desbloqueado',
    101867: '*Os ganhos de comissão precisam ser retirados para Minha Conta Spot para serem usados.',
    101868: 'Confirmação de Saque',
    101869: 'Tem certeza de que deseja retirar todos os tokens para a minha conta Spot?',
    101870: 'Os tokens atuais não atendem ao valor de retirada. Você pode convidar mais usuários para negociar e receber recompensas.',
    101871: 'Desbloqueado',
    101872: 'Revertido',
    101873: 'Qualificação de agente cancelada',
    101874: 'Já é um agente',
    101875: 'Visão Geral dos Dados do Canal',
    101876: 'Dados de Usuário',
    101877: 'Para a conta de futuros da carteira na nuvem',
    101878: 'Para a Conta Spot da Carteira em Nuvem',
    101879: 'Detalhes de Negociação Spot',
    101880: 'Detalhes de Negociação Futuros',
    101881: 'Centro de Liquidação de Contratos',
    101882: 'Centro de Liquidação Spot',
    101883: 'Relatório de Eficácia',
    101884: 'Selecionar idioma',
    101885: 'Digite sua resposta',
    101886: 'Selecione o nome do canal',
    101887: 'Retirada de Comissão',
    101888: 'Digite o nome do canal',
    101889: 'Selecione o método de promoção',
    101890: 'Insira notas',
    101891: 'Ativos disponíveis para saque',
    101892: 'Confirmar saque',
    101893: 'Definir a proporção de reembolso para usuários de futuros.',
    101894: 'Definir a proporção de reembolso de usuário em Spot',
    101895: 'Relatório de Desempenho de Contratos',
    101896: 'Relatório de Desempenho Spot',
    101897: 'Conversão (USDT)',
    101898: 'Retirar para a Carteira na Nuvem',
    101899: 'Tem certeza de que deseja retirar todas as suas comissões à vista para a sua carteira na nuvem?',
    101900: 'Ver Fundos',
    101901: 'Todas as moedas',
    101902: 'Não retirado',
    101903: 'Comissão Total',
    101904: "Por favor, selecione um país ou região",
    101905: "Digite o código de verificação",
    101906: "Sistema de agentes",
    101907: "Obrigado.",
    101908: "Sua aplicação foi enviada. Normalmente, revisamos suas informações em 2-3 dias úteis, e sua comissão será ativa após a aprovação!",
    //代理商拉新
    92000000:'Contagem regressiva',
    92000001:'Método de participação',
    92000002:'Você precisa garantir que a conta que completa a tarefa corresponde à sua conta registrada/conectada na página atual para ter a chance de ganhar recompensas.',
    92000003:'Aguardando verificação da tarefa',
    92000004:'Registre-se no SuperEx por convite de <span style="color:#000922;font-weight:500;">{brokerName}</span> para desbloquear bônus de boas-vindas por tempo limitado!',
    92000005:'Começar a partir de {time}',
    92000006:'Completar até {time}',
    92000007:'A verificação de conclusão da tarefa pode levar até 7 dias úteis, por favor seja paciente.',
    92000008:'Cerca de 7 dias após o evento',
    92000009:'A recompensa será distribuída na conta dentro de 7 dias úteis após a validação do evento.',
    92000010:'Registrar-se usando o link de convite de <span style="color:#000922;font-weight:400;">{brokerName}</span>',
    92000011:'Termos e condições',
    92000012:'Atividade em progresso',
    92000013:'Não é possível participar deste evento',
    92000014:'Evento encerrado',
    92000015:'Reivindicar Recompensa',
    92000016:'Faça login agora',
    92000017:'Por favor, defina um apelido',

    92000018:'Observações',
    92000019:'Este item é obrigatório',
    92000020:'Salvar',
    92000021:'Compartilhar pôster',
    92000022:'Máx',
    92000023:'Editar canal',
    92000024:'Criar canal afiliado',
    92000025:'Sem código de convite neste canal',
    92000026:'',
    92000027:'',
    92000028:'',
    92000029:'',
    92000030:'',
 }
 export default pt
 


// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/pt.js